import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { createCategory } from '../../graphql/mutation';
import { 
  Card, 
  Form, 
  Input, 
  InputNumber,
  Button, 
  Space, 
  Row, 
  Col 
} from 'antd';
import { showSnackBar } from '../../components/SnackBar/SnackBar';
import './CreateCategory.css';

const CreateCategory = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const [createCategoryMutation] = useMutation(createCategory);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      await createCategoryMutation({
        variables: {
          name: values.name,
          rowNumber: values.rowNumber,
        }
      });

      showSnackBar('success', 'Success', 'Category created successfully');
      navigate('/categories');
    } catch (error) {
      showSnackBar('error', 'Error', error.message || 'Failed to create category');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-category-container">
      <Card title="Create Category">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: 'Please enter category name' }]}
              >
                <Input placeholder="Enter category name" />
              </Form.Item>

              <Form.Item
                name="rowNumber"
                label="Row Number"
                rules={[{ required: true, message: 'Please enter row number' }]}
              >
                <InputNumber 
                  min={1} 
                  placeholder="Enter row number"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                Create Category
              </Button>
              <Button onClick={() => navigate('/categories')}>
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateCategory; 